export default __webpack_public_path__ + "static/media/H4006.aefa5109.mp3";